import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, requireOnboarding = true }) {
  const location = useLocation();
  const { user, onboarding, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#f7f3ea] flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-[#e6dcc6] border-t-[#486a8f] rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/start" replace state={{ from: location }} />;
  }
  if (requireOnboarding && !onboarding?.completed) {
    // Send fresh users to mentor select; resume the chat flow if mentor already chosen.
    return <Navigate to={onboarding?.mentor_id ? "/welcome" : "/mentor"} replace />;
  }
  return children;
}
